@let blok = block();
<app-cms-layout [layout]="layout()">
  @for(child of blok.body; track child['_uid']){
      <s1-cms-component [blok]="child">
      </s1-cms-component>
  }
  @if(blok.tarifBottomCTA && blok.tarifBottomCTA[0]){
      <s1-cms-component [blok]="blok.tarifBottomCTA[0]">
      </s1-cms-component>
  }
</app-cms-layout>


